/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { MediumText, DISABLED } from '../../../styles/styles';


/**
 * A common, styled Select (combobox). Recommend using the corresponding Option component.
 * @deprecated
 */
export const Select = styled('select')`
  width: 100%;
  height: 49px; /* Same height as a single-line button */
  ${MediumText};
  cursor: pointer;
  
  &:disabled {
    ${DISABLED}
  } 
   
  option {
    ${MediumText};
  }
`;

